<template>
  <div>
    <div class="btn-bar">
      <Button type="warning" @click="toDetail()">新增结算报表</Button>
    </div>
    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="reportName">
          <span class="report-name" @click="toDetail(row)">{{ row.reportName }}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <Poptip v-if="row.settlementStatus * 1 === 1" placement="left" transfer :max-width="100" trigger="hover" content="已结算报表不可删除">
              <span class="table-btn red disabled">删除</span>
            </Poptip>
            <span v-else class="table-btn red" @click="row.settlementStatus == 0 && delItem(row)">删除</span>
          </div>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        :page-size-opts="[10, 20, 30, 50, 100]"
        style="text-align: center"
      />
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import { config } from '../index.config.js';

const LIST_URL = '/buz/ifaSettlementReport/read/list';
const DELETE_URL = '/buz/ifaSettlementReport/del';

const DEFAULT_SEARCH_PARAMS = {
  reportName: '',
  settlementDate: [],
  settlementStatus: ''
};

export default {
  name: 'BasicTab',
  mixins: [pageTool, common, config],
  data() {
    return {
      searchParams: { ...DEFAULT_SEARCH_PARAMS }
    };
  },
  mounted() {
    this.getColumns();
    this.initListParams(LIST_URL);
  },
  activated() {
    this.getList();
  },
  methods: {
    toDetail(item = null) {
      if (!item) {
        this.$router.push({
          path: '/basicLaw/add',
          query: {
            timeStamp: new Date().getTime(),
            backUrl: '/basicLaw/index',
            reportType: 'basic'
          }
        });
      } else {
        this.$router.push({
          path: '/basicLaw/edit',
          query: {
            backUrl: '/basicLaw/index',
            id: item.id,
            isSummary: item.isSummary,
            reportName: item.reportName,
            settlementStatus: item.settlementStatus,
            reportType: 'basic',
            timeStamp: new Date().getTime()
          }
        });
      }
    },
    delItem(row) {
      if (row.settlementStatus == 1) {
        this.$notice.error('已结算的报表不能删除');
        return;
      }
      this.$notice.inquiry('请确认是否删除此结算报表？').then(async () => {
        this.$http({
          url: DELETE_URL,
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('操作成功');
          this.pageNum = 1;
          this.getList();
        });
      });
    },
    setListParams(params) {
      if (params.settlementDate && params.settlementDate[0]) {
        params.startDate = params.settlementDate[0];
        params.endDate = params.settlementDate[1];
      }
      delete params.settlementDate;
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined || (Array.isArray(params[key]) && params[key].length === 0)) {
          delete params[key];
        }
      });
    },
    resetSearch() {
      this.searchParams = JSON.parse(JSON.stringify(this.searchParamsOrigin));
      this.searchAjax();
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled {
  cursor: not-allowed;
  color: #c0c4cc;
}
.report-name {
  color: #236dff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.btn-bar {
  margin-bottom: 10px;
}
</style>
